import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { getPageLang } from './utils';

document.addEventListener('DOMContentLoaded', async () => {
  const dateInputs = document.querySelectorAll('.input__date');

  dateInputs.forEach((input) => {
    flatpickr(input, {
      altInput: false,
      dateFormat: 'F j, Y',
      minDate: 'today',
      locale: getPageLang() === 'fr' ? French : undefined,
    });
  });
});

